import barba from '@barba/core';
import barbaRouter from '@barba/router';

import $ from 'jquery';
import './libs/jquery.inview';
import './libs/slick';
import './libs/remodal';

// KV, Loading, BgRedCircles
import KV from './kv/KV';
import Loading from './loading/Loading';
import BgRedCircles from './bgRedCircle/BgRedCircles';

import data from '../static/medea.json';

var list = data.filter(function (item) {
  console.log(item.filter);
  var a = item.filter.includes('fashion');
  return item;
});

//import './libs/parallax';

import {
  leaveAnimation,
  enterAnimation,
  topEvent,
  underlayerEvent
} from './libs/pageentry';
import { wait } from './kv/utils/timer';

const myRoutes = [
  {
    path: '(/|/index.html)',
    name: 'home'
  },
  {
    path: '(/gallery/|/gallery.html)',
    name: 'gallery'
  },
  {
    path: '(/impacts/|/impacts.html)',
    name: 'impacts'
  },
  {
    path: '(/media/|/media.html)',
    name: 'media'
  },
  {
    path: '(/event/shibuya/|/event/shibuya.html)',
    name: 'event'
  }
];

barba.use(barbaRouter, {
  routes: myRoutes
});

/*!
 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images or videos,
 * @date: 20-08-2020 14:0:14,
 * @version: 5.6.2,
 * @link: https://simpleparallax.com/
 */
!(function (t, e) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
    ? define('simpleParallax', [], e)
    : 'object' == typeof exports
    ? (exports.simpleParallax = e())
    : (t.simpleParallax = e());
})(window, function () {
  return (function (t) {
    var e = {};
    function n(i) {
      if (e[i]) return e[i].exports;
      var r = (e[i] = { i: i, l: !1, exports: {} });
      return t[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
    }
    return (
      (n.m = t),
      (n.c = e),
      (n.d = function (t, e, i) {
        n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
      }),
      (n.r = function (t) {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(t, '__esModule', { value: !0 });
      }),
      (n.t = function (t, e) {
        if ((1 & e && (t = n(t)), 8 & e)) return t;
        if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
        var i = Object.create(null);
        if (
          (n.r(i),
          Object.defineProperty(i, 'default', { enumerable: !0, value: t }),
          2 & e && 'string' != typeof t)
        )
          for (var r in t)
            n.d(
              i,
              r,
              function (e) {
                return t[e];
              }.bind(null, r)
            );
        return i;
      }),
      (n.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return n.d(e, 'a', e), e;
      }),
      (n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (n.p = ''),
      n((n.s = 0))
    );
  })([
    function (t, e, n) {
      'use strict';
      n.r(e),
        n.d(e, 'default', function () {
          return x;
        });
      var i = function () {
        return Element.prototype.closest && 'IntersectionObserver' in window;
      };
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            'value' in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var s = new ((function () {
          function t() {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError('Cannot call a class as a function');
            })(this, t),
              (this.positions = { top: 0, bottom: 0, height: 0 });
          }
          var e, n, i;
          return (
            (e = t),
            (n = [
              {
                key: 'setViewportTop',
                value: function (t) {
                  return (
                    (this.positions.top = t ? t.scrollTop : window.pageYOffset),
                    this.positions
                  );
                }
              },
              {
                key: 'setViewportBottom',
                value: function () {
                  return (
                    (this.positions.bottom =
                      this.positions.top + this.positions.height),
                    this.positions
                  );
                }
              },
              {
                key: 'setViewportAll',
                value: function (t) {
                  return (
                    (this.positions.top = t ? t.scrollTop : window.pageYOffset),
                    (this.positions.height = t
                      ? t.clientHeight
                      : document.documentElement.clientHeight),
                    (this.positions.bottom =
                      this.positions.top + this.positions.height),
                    this.positions
                  );
                }
              }
            ]) && r(e.prototype, n),
            i && r(e, i),
            t
          );
        })())(),
        o = function (t) {
          return NodeList.prototype.isPrototypeOf(t) ||
            HTMLCollection.prototype.isPrototypeOf(t)
            ? Array.from(t)
            : 'string' == typeof t || t instanceof String
            ? document.querySelectorAll(t)
            : [t];
        },
        a = (function () {
          for (
            var t,
              e =
                'transform webkitTransform mozTransform oTransform msTransform'.split(
                  ' '
                ),
              n = 0;
            void 0 === t;

          )
            (t =
              void 0 !== document.createElement('div').style[e[n]]
                ? e[n]
                : void 0),
              (n += 1);
          return t;
        })(),
        l = function (t) {
          return (
            ('img' !== t.tagName.toLowerCase() &&
              'picture' !== t.tagName.toLowerCase()) ||
            (!!t &&
              !!t.complete &&
              (void 0 === t.naturalWidth || 0 !== t.naturalWidth))
          );
        };
      function u(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return c(t);
          })(t) ||
          (function (t) {
            if ('undefined' != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ('string' == typeof t) return c(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            'Object' === n && t.constructor && (n = t.constructor.name);
            if ('Map' === n || 'Set' === n) return Array.from(t);
            if (
              'Arguments' === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return c(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          })()
        );
      }
      function c(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }
      function h(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            'value' in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var f = (function () {
        function t(e, n) {
          var i = this;
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t),
            (this.element = e),
            (this.elementContainer = e),
            (this.settings = n),
            (this.isVisible = !0),
            (this.isInit = !1),
            (this.oldTranslateValue = -1),
            (this.init = this.init.bind(this)),
            (this.customWrapper =
              this.settings.customWrapper &&
              this.element.closest(this.settings.customWrapper)
                ? this.element.closest(this.settings.customWrapper)
                : null),
            l(e)
              ? this.init()
              : this.element.addEventListener('load', function () {
                  setTimeout(function () {
                    i.init(!0);
                  }, 50);
                });
        }
        var e, n, i;
        return (
          (e = t),
          (n = [
            {
              key: 'init',
              value: function (t) {
                var e = this;
                this.isInit ||
                  (t && (this.rangeMax = null),
                  this.element.closest('.simpleParallax') ||
                    (!1 === this.settings.overflow &&
                      this.wrapElement(this.element),
                    this.setTransformCSS(),
                    this.getElementOffset(),
                    this.intersectionObserver(),
                    this.getTranslateValue(),
                    this.animate(),
                    this.settings.delay > 0
                      ? setTimeout(function () {
                          e.setTransitionCSS(),
                            e.elementContainer.classList.add(
                              'simple-parallax-initialized'
                            );
                        }, 10)
                      : this.elementContainer.classList.add(
                          'simple-parallax-initialized'
                        ),
                    (this.isInit = !0)));
              }
            },
            {
              key: 'wrapElement',
              value: function () {
                var t = this.element.closest('picture') || this.element,
                  e = this.customWrapper || document.createElement('div');
                e.classList.add('simpleParallax'),
                  (e.style.overflow = 'hidden'),
                  this.customWrapper ||
                    (t.parentNode.insertBefore(e, t), e.appendChild(t)),
                  (this.elementContainer = e);
              }
            },
            {
              key: 'unWrapElement',
              value: function () {
                var t = this.elementContainer;
                this.customWrapper
                  ? (t.classList.remove('simpleParallax'),
                    (t.style.overflow = ''))
                  : t.replaceWith.apply(t, u(t.childNodes));
              }
            },
            {
              key: 'setTransformCSS',
              value: function () {
                !1 === this.settings.overflow &&
                  (this.element.style[a] = 'scale('.concat(
                    this.settings.scale,
                    ')'
                  )),
                  (this.element.style.willChange = 'transform');
              }
            },
            {
              key: 'setTransitionCSS',
              value: function () {
                this.element.style.transition = 'transform '
                  .concat(this.settings.delay, 's ')
                  .concat(this.settings.transition);
              }
            },
            {
              key: 'unSetStyle',
              value: function () {
                (this.element.style.willChange = ''),
                  (this.element.style[a] = ''),
                  (this.element.style.transition = '');
              }
            },
            {
              key: 'getElementOffset',
              value: function () {
                var t = this.elementContainer.getBoundingClientRect();
                if (
                  ((this.elementHeight = t.height),
                  (this.elementTop = t.top + s.positions.top),
                  this.settings.customContainer)
                ) {
                  var e = this.settings.customContainer.getBoundingClientRect();
                  this.elementTop = t.top - e.top + s.positions.top;
                }
                this.elementBottom = this.elementHeight + this.elementTop;
              }
            },
            {
              key: 'buildThresholdList',
              value: function () {
                for (var t = [], e = 1; e <= this.elementHeight; e++) {
                  var n = e / this.elementHeight;
                  t.push(n);
                }
                return t;
              }
            },
            {
              key: 'intersectionObserver',
              value: function () {
                var t = { root: null, threshold: this.buildThresholdList() };
                (this.observer = new IntersectionObserver(
                  this.intersectionObserverCallback.bind(this),
                  t
                )),
                  this.observer.observe(this.element);
              }
            },
            {
              key: 'intersectionObserverCallback',
              value: function (t) {
                var e = this;
                t.forEach(function (t) {
                  t.isIntersecting ? (e.isVisible = !0) : (e.isVisible = !1);
                });
              }
            },
            {
              key: 'checkIfVisible',
              value: function () {
                return (
                  this.elementBottom > s.positions.top &&
                  this.elementTop < s.positions.bottom
                );
              }
            },
            {
              key: 'getRangeMax',
              value: function () {
                var t = this.element.clientHeight;
                this.rangeMax = t * this.settings.scale - t;
              }
            },
            {
              key: 'getTranslateValue',
              value: function () {
                var t = (
                  (s.positions.bottom - this.elementTop) /
                  ((s.positions.height + this.elementHeight) / 100)
                ).toFixed(1);
                return (
                  (t = Math.min(100, Math.max(0, t))),
                  0 !== this.settings.maxTransition &&
                    t > this.settings.maxTransition &&
                    (t = this.settings.maxTransition),
                  this.oldPercentage !== t &&
                    (this.rangeMax || this.getRangeMax(),
                    (this.translateValue = (
                      (t / 100) * this.rangeMax -
                      this.rangeMax / 2
                    ).toFixed(0)),
                    this.oldTranslateValue !== this.translateValue &&
                      ((this.oldPercentage = t),
                      (this.oldTranslateValue = this.translateValue),
                      !0))
                );
              }
            },
            {
              key: 'animate',
              value: function () {
                var t,
                  e = 0,
                  n = 0;
                (this.settings.orientation.includes('left') ||
                  this.settings.orientation.includes('right')) &&
                  (n = ''.concat(
                    this.settings.orientation.includes('left')
                      ? -1 * this.translateValue
                      : this.translateValue,
                    'px'
                  )),
                  (this.settings.orientation.includes('up') ||
                    this.settings.orientation.includes('down')) &&
                    (e = ''.concat(
                      this.settings.orientation.includes('up')
                        ? -1 * this.translateValue
                        : this.translateValue,
                      'px'
                    )),
                  (t =
                    !1 === this.settings.overflow
                      ? 'translate3d('
                          .concat(n, ', ')
                          .concat(e, ', 0) scale(')
                          .concat(this.settings.scale, ')')
                      : 'translate3d('.concat(n, ', ').concat(e, ', 0)')),
                  (this.element.style[a] = t);
              }
            }
          ]) && h(e.prototype, n),
          i && h(e, i),
          t
        );
      })();
      function m(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return y(t);
          })(t) ||
          (function (t) {
            if ('undefined' != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          d(t) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          })()
        );
      }
      function p(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            if ('undefined' == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var n = [],
              i = !0,
              r = !1,
              s = void 0;
            try {
              for (
                var o, a = t[Symbol.iterator]();
                !(i = (o = a.next()).done) &&
                (n.push(o.value), !e || n.length !== e);
                i = !0
              );
            } catch (t) {
              (r = !0), (s = t);
            } finally {
              try {
                i || null == a.return || a.return();
              } finally {
                if (r) throw s;
              }
            }
            return n;
          })(t, e) ||
          d(t, e) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          })()
        );
      }
      function d(t, e) {
        if (t) {
          if ('string' == typeof t) return y(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return (
            'Object' === n && t.constructor && (n = t.constructor.name),
            'Map' === n || 'Set' === n
              ? Array.from(t)
              : 'Arguments' === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              ? y(t, e)
              : void 0
          );
        }
      }
      function y(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }
      function v(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            'value' in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var g,
        b,
        w = !1,
        T = [],
        x = (function () {
          function t(e, n) {
            if (
              ((function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError('Cannot call a class as a function');
              })(this, t),
              e && i())
            ) {
              if (
                ((this.elements = o(e)),
                (this.defaults = {
                  delay: 0,
                  orientation: 'up',
                  scale: 1.3,
                  overflow: !1,
                  transition: 'cubic-bezier(0,0,0,1)',
                  customContainer: '',
                  customWrapper: '',
                  maxTransition: 0
                }),
                (this.settings = Object.assign(this.defaults, n)),
                this.settings.customContainer)
              ) {
                var r = p(o(this.settings.customContainer), 1);
                this.customContainer = r[0];
              }
              (this.lastPosition = -1),
                (this.resizeIsDone = this.resizeIsDone.bind(this)),
                (this.refresh = this.refresh.bind(this)),
                (this.proceedRequestAnimationFrame =
                  this.proceedRequestAnimationFrame.bind(this)),
                this.init();
            }
          }
          var e, n, r;
          return (
            (e = t),
            (n = [
              {
                key: 'init',
                value: function () {
                  var t = this;
                  s.setViewportAll(this.customContainer),
                    (T = [].concat(
                      m(
                        this.elements.map(function (e) {
                          return new f(e, t.settings);
                        })
                      ),
                      m(T)
                    )),
                    w ||
                      (this.proceedRequestAnimationFrame(),
                      window.addEventListener('resize', this.resizeIsDone),
                      (w = !0));
                }
              },
              {
                key: 'resizeIsDone',
                value: function () {
                  clearTimeout(b), (b = setTimeout(this.refresh, 200));
                }
              },
              {
                key: 'proceedRequestAnimationFrame',
                value: function () {
                  var t = this;
                  s.setViewportTop(this.customContainer),
                    this.lastPosition !== s.positions.top
                      ? (s.setViewportBottom(),
                        T.forEach(function (e) {
                          t.proceedElement(e);
                        }),
                        (g = window.requestAnimationFrame(
                          this.proceedRequestAnimationFrame
                        )),
                        (this.lastPosition = s.positions.top))
                      : (g = window.requestAnimationFrame(
                          this.proceedRequestAnimationFrame
                        ));
                }
              },
              {
                key: 'proceedElement',
                value: function (t) {
                  (this.customContainer ? t.checkIfVisible() : t.isVisible) &&
                    t.getTranslateValue() &&
                    t.animate();
                }
              },
              {
                key: 'refresh',
                value: function () {
                  s.setViewportAll(this.customContainer),
                    T.forEach(function (t) {
                      t.getElementOffset(), t.getRangeMax();
                    }),
                    (this.lastPosition = -1);
                }
              },
              {
                key: 'destroy',
                value: function () {
                  var t = this,
                    e = [];
                  (T = T.filter(function (n) {
                    return t.elements.includes(n.element) ? (e.push(n), !1) : n;
                  })),
                    e.forEach(function (e) {
                      e.unSetStyle(),
                        !1 === t.settings.overflow && e.unWrapElement();
                    }),
                    T.length ||
                      (window.cancelAnimationFrame(g),
                      window.removeEventListener('resize', this.refresh),
                      (w = !1));
                }
              }
            ]) && v(e.prototype, n),
            r && v(e, r),
            t
          );
        })();
    }
  ]).default;
});

var image = document.getElementsByClassName('js-plx');
new simpleParallax(image, { delay: 0.6, transition: 'cubic-bezier(0,0,0,1)' });

$(function () {
  // -------------------------------------
  //  language
  // -------------------------------------
  const re = /locale=en/;
  const en = re.exec(location.search);

  if (en) {
    $('.jp').toggle();
    $('.en').toggle();
    $('.header__lang a').toggleClass('-cr');
    $('.spNav__nav__lang a').toggleClass('-cr');
  }

  $('.header__lang a,.spNav__nav__lang a').on('click', function () {
    $('.jp').toggle();
    $('.en').toggle();
    $('.header__lang a').toggleClass('-cr');
    $('.spNav__nav__lang a').toggleClass('-cr');

    if ($(this).parent().parent().attr('class') === 'spNav__nav__lang') {
      $('.spNav').fadeToggle();
      $('html').toggleClass('is-lock');
    }
    return false;
  });

  // -------------------------------------
  //  barba init
  // -------------------------------------
  barba.init({
    transitions: [
      {
        name: 'default-transition',

        leave(data) {
          // 遷移元画面の非表示になるtransition
          return leaveAnimation(data).catch((error) => console.error(error));
        },

        enter(data) {
          // 遷移画面を表示するときに使うtransition
          $(window).scrollTop(0);
          return enterAnimation(data).catch((error) => console.error(error));
        },

        beforeLeave(data) {
          console.log('before leave');
          bgRedCircles.hide();
        },

        afterLeave(data) {
          console.log('after leave');
          if (data.next.namespace !== 'index') {
            // 下層の場合はフェードアウト後にKVを非活性化
            kv.deactivate();
          }
        },

        async beforeEnter(data) {
          if (data.current.route === void 0) {
            // 初期表示
            return;
          }
          console.log('before enter', data);
          //console.log($('body').attr('id'));
          $('body').attr('id', data.next.route.name);
          console.log($('body').attr('id'));

          data.next.container.id = data.next.namespace;
          if (data.next.namespace === 'index') {
            // TOPページを表示する前の処理
            topEvent();
            await wait(0.1);
            await kv.activate();
            kv.play();
            bgRedCircles.setMode(true, data.next.container);
            bgRedCircles.show(1);
            setFaqBtn();
          } else {
            // 下層を表示する前の処理
            underlayerEvent();
            bgRedCircles.setMode(false, data.next.container);
            bgRedCircles.show(0);
          }

          // 言語の反映

          console.log('--->' + $('.header__lang a').eq(1).hasClass('-cr'));

          if ($('.header__lang a').eq(1).hasClass('-cr') == true) {
            // 英語設定
            $('.jp').hide();
            $('.en').show();
          } else {
            $('.jp').show();
            $('.en').hide();
          }
        },

        afterEnter(data) {
          console.log(`after Enter`);
          console.log('6666))))))666666', data.next.url.hash);
          if (data.next.url.hash !== undefined) {
            console.log('6666666666', data.next.url.hash);

            const speed = 500;
            const target = $(`#${data.next.url.hash}`);
            const position = target.offset().top;
            $('html, body').animate({ scrollTop: position }, speed, 'swing');
          }
        }
      }
    ]
  });

  const setFaqBtn = () => {
    $('.js-faqBox .faqBox__head').on('click', function () {
      var $btn = $(this);
      console.log('QUESTION CLICK');

      if ($btn.hasClass('-open')) {
        $btn.toggleClass('-open');
        $btn.next().slideToggle();
      } else {
        $('.faqBox__body').slideUp();
        $('.js-faqBox .faqBox__head').removeClass('-open');
        $btn.toggleClass('-open');
        $btn.next().slideToggle();
      }
    });
  };

  // -----------------------------------------
  //  KV + Loading + bgRedCircles by hasegawa
  // -----------------------------------------
  let kv, loading, bgRedCircles;
  (async () => {
    bgRedCircles = new BgRedCircles();
    kv = new KV();
    loading = new Loading(() => {
      // KVからローディングの進捗を取得して、ローディングの％に反映
      loading.setPercent(kv.getLoadedPercent());
    });
    loading.start();

    // KVイニシャライズ
    await Promise.all([bgRedCircles.init(), kv.init()]);

    // イニシャライズ完了 = ロード完了
    // ローディング％を100に設定
    loading.setPercent(100);

    // トップページではKVが有効
    const initialNamespace = document
      .querySelector('[data-barba-namespace]')
      .getAttribute('data-barba-namespace');
    console.log(initialNamespace);

    let bgRedCirclesDelay = 0;
    if (initialNamespace === 'index') {
      await kv.activate();
      bgRedCircles.setMode(true);
      topEvent();
      bgRedCirclesDelay = 1;
    } else {
      kv.deactivate();
      bgRedCircles.setMode(false);
      underlayerEvent();
    }
    bgRedCircles.start();

    // アクティベートが完了してからローディングをフェードアウト
    await loading.fadeOut();

    // KV再生開始
    kv.play();
    console.log(bgRedCirclesDelay);
    bgRedCircles.show(bgRedCirclesDelay);
  })();

  $('a[href^="#"]').on('click', function () {
    if ($('#index').length == 0) {
      return;
    }
    var speed = 500;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  $('.js-spNavBtn,.spNav .linkList a').on('click', function () {
    $('.spNav').fadeToggle();
    $('html').toggleClass('is-lock');
  });

  //kvH100%
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  let vw = window.innerWidth;

  window.addEventListener('resize', () => {
    if (vw === window.innerWidth) {
      // 画面の横幅にサイズ変動がないので処理を終える
      return;
    }

    // 画面の横幅のサイズ変動があった時のみ高さを再計算する
    vw = window.innerWidth;
    setFillHeight();
  });

  // 初期化
  setFillHeight();
  //-kvH100%

  sound();

  function sound() {
    //sound
    'use strict';
    var playlist = [
      '/assets/sound/red.mp3',
      '/assets/sound/NextGenerationSequencing.mp3'
    ];

    var audio = document.createElement('audio');
    document.body.appendChild(audio);
    audio.style.width = '100%';
    audio.style.height = 'auto';
    audio.controls = true;
    audio.volume = 0.2;

    audio.src = playlist[0];
    //audio.play();

    var index = 0;
    audio.addEventListener('ended', function () {
      index++;
      $('.audioBlock .audioTtl').hide();

      if (index < playlist.length) {
        audio.src = playlist[index];
        audio.play();
        $('.audioBlock .-sound' + index).show();
      } else {
        audio.src = playlist[0];
        audio.play();
        index = 0;
        $('.audioBlock .-sound' + index).show();
      }
    });

    var $musicStat = 'mPause';
    $('.js-audio').on('click', function () {
      if ($musicStat == 'mPause') {
        audio.play();
        $musicStat = 'mPlay';
        $('.js-audio').addClass('-play');
      } else {
        audio.pause();
        $musicStat = 'mPause';
        $('.js-audio').removeClass('-play');
      }
      //console.log($musicStat);
    });
  }

  brwsrEvtCmn();
  window.addEventListener('resize', function (e) {
    brwsrEvtCmn();
  });
  window.addEventListener('scroll', function (e) {
    brwsrEvtCmn();
  });
  // window.onscroll = function () {
  //   // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //   brwsrEvtCmn();
  // };

  var $y = window.scrollY;

  function brwsrEvtCmn() {
    if (window.scrollY > window.innerHeight - 1) {
      $('body').addClass('-fvPast');
    } else {
      $('body').removeClass('-fvPast');
    }
  }

  if ($('#index').length > 0) {
    setFaqBtn();

    //console.log($('.js-txtW span').width());

    //about
    // var $aboutTop = $('.secAbout').offset().top,
    // 	$aboutBottom = $('.secAbout').offset().top+$('.secAbout').height(),
    // 	$cntPosition1 = $('#aboutBox1').offset().top,
    // 	$cntPosition2 = $('#aboutBox2').offset().top,
    // 	$cntPosition3 = $('#aboutBox3').offset().top;
    //brwsrEvt
    var $wH, $brwsw, $y;

    brwsrEvt();
    window.addEventListener('resize', function (e) {
      brwsrEvt();
    });
    window.onscroll = function () {
      brwsrEvt();
    };
    var addjst = 0;
    function brwsrEvt() {
      ($wH = window.innerHeight),
        ($brwsw = window.innerWidth),
        ($y = window.scrollY);
    }

    //
    // $('.secRoadmap__body').hover(
    // 	function () {
    // 		$('.js-rmImgBox').addClass('-in')
    // 	}, function () {
    // 		$('.js-rmImgBox').removeClass('-in')
    // 	}
    // );

    //roadmap
    $('.rmBox__in').hover(
      function () {
        $('#stalker').removeClass('-def');
        var $item = $(this).data('imgsrc');
        //console.log($item);
        //$('.js-rmImg').addClass('-in');
        $('.js-rmImg').stop().fadeIn();
        $('.js-rmImg').attr('src', $item);
      },
      function () {
        //$('.js-rmImg').removeClass('-in');
        $('.js-rmImg').stop().fadeOut();
      }
    );

    //画像先読み
    var rmImgList = [];
    $('.rmBox').each(function () {
      rmImgList.push($('.rmBox__in', this).attr('data-imgsrc'));
    });
    document.addEventListener('DOMContentLoaded', function () {
      for (var i = 0; i < rmImgList.length; i++) {
        var img = new Image();
        img.src = rmImgList[i];
      }
    });

    //モーダルスクロールバー調整
    let scrollbarWidth = window.innerWidth - document.body.clientWidth;

    $(document).on('opening', '.remodal', function () {
      $('.header__nav ul').css({ 'padding-right': scrollbarWidth });
      $('.rmMdlCnt__close').on('click', function () {
        $(this).fadeOut(function () {
          $(this).show();
        });
      });
    });

    $(document).on('closed', '.remodal', function (e) {
      $('.header__nav ul').css({ 'padding-right': '0' });
    });

    $('.remodal-wrapper').append(
      '<div class="rmMdlCnt__close"><a class="-txtHvrMov -txtHvrMov__bg" data-remodal-action="close"><span class="rmMdlCnt__close__txt -txtHvrMov__wrp"><span class="-txtHvrMov__base">CLOSE</span><span class="-txtHvrMov__ov">CLOSE</span></span><img class="rmMdlCnt__close__icon" src="/assets/images/index/modal-close.svg"></a></div>'
    );
    //-roadmap

    //マウスストーカー
    mStalker();
    function mStalker() {
      //マウスストーカー用のdivを取得
      const stalker = document.getElementById('stalker');

      //aタグにホバー中かどうかの判別フラグ
      let hovFlag = false;

      //マウスに追従させる処理 （リンクに吸い付いてる時は除外する）
      document.addEventListener('mousemove', function (e) {
        if (!hovFlag) {
          stalker.style.transform =
            'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
        }
      });

      //リンクへ吸い付く処理
      const linkElem = document.querySelectorAll('a:not(.no_stick_)');
      for (let i = 0; i < linkElem.length; i++) {
        //マウスホバー時
        linkElem[i].addEventListener('mouseover', function (e) {
          hovFlag = true;

          //マウスストーカーにクラスをつける
          stalker.classList.add('hov_');

          //マウスストーカーの位置をリンクの中心に固定
          let rect = e.target.getBoundingClientRect();
          let posX = rect.left + rect.width / 2;
          let posY = rect.top + rect.height / 2;

          stalker.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';
        });
        //マウスホバー解除時
        linkElem[i].addEventListener('mouseout', function (e) {
          hovFlag = false;
          stalker.classList.remove('hov_');
        });
      }
    }

    //team
    $('.teamBox').each(function () {
      var $box = $(this),
        $pcTxt = $('.js-txtBlock-pc', $box),
        //$pcTxtH = $('.teamBox__txtBlock__pcIn', $box).height(),
        $pcBtnMore = $('.js-teamProfVm-pc', $box),
        $pcBtnClose = $('.js-teamProfClose-pc', $box);

      $pcBtnMore.on('click', function () {
        $pcTxt.height($('.teamBox__txtBlock__pcIn', $box).height());
        $pcTxt.addClass('-open');
        $box.addClass('-openPc');
      });
      // $pcBtnClose.on('click', function () {
      //   $pcTxt.height(215);
      //   $pcTxt.removeClass('-open');
      //   $box.removeClass('-openPc');
      // });
    });

    $('.js-teamProfVm-pc').on('click', function () {
      $('.secTeam__body').addClass('-pcOpen');
    });
    $('.js-teamProfClose-pc').on('click', function () {
      $('.secTeam__body').removeClass('-pcOpen');

      $('.js-txtBlock-pc').height(215);
      $('.js-txtBlock-pc').removeClass('-open');
      $('.teamBox').removeClass('-openPc');
    });

    //teamSP
    teamRszEvt();
    window.addEventListener('resize', function (e) {
      teamRszEvt();
    });
    function teamRszEvt() {
      const contentsWidth = $('.teamTxtList').width() + $('.teamList').width();
      console.log('****AAAAA****');
      console.log(contentsWidth, $(window).width());
      if (contentsWidth > $(window).width()) {
        $('.teamSpMdlWrp').width(
          $('.teamTxtList').width() + $('.teamList').width() + 30
        );
        return;
      }
      $('.teamSpMdlWrp').width($(window).width());
    }

    $('.js-teamProfVm-sp').on('click', function () {
      var $id = $(this).data('profmodal');
      var $left = $('.secTeam__body').scrollLeft();
      $('.teamSpMdlWrp').fadeIn();
      $('.teamSpMdlCnt.-' + $id).show();
      $('.teamSpMdlWrp__in').css({ left: $left });
      //console.log($left);

      $('.secTeam__body').addClass('-spOpen');
    });

    $('.js-teamProfClose-sp').on('click', function () {
      $('.teamSpMdlWrp').fadeOut(function () {
        $('.teamSpMdlCnt').hide();
        $('.secTeam__body').removeClass('-spOpen');
      });
    });

    $('.secTeam__body').on('inview', function (event, isInView) {
      $(this).addClass('-spView');
    });

    $(document).click(function (event) {
      if (window.matchMedia('(max-width: 1100px)').matches) {
        if (!$(event.target).closest('.secTeam__body').length) {
          $('.teamSpMdlWrp').fadeOut(function () {
            $('.teamSpMdlCnt').hide();
            $('.secTeam__body').removeClass('-spOpen');
          });
        }
      }
    });
    //-/team
  } //index
  //sound

  //ABOUT部分モバイル高さ固定
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
    // スマホ・タブレット（iOS・Android）の場合の処理を記述
    //$('#index .secAbout').height(window.innerHeight * 3);
    //$('#index .secAbout .secAboutBox').height(window.innerHeight);
  }
  //inview
  // $('.js-iv').on('inview', function() {
  // 	$(this).addClass('viewed');
  // });

  //slick
  // $('.exSlick').slick({
  // 	fade:true,
  //     autoplay:true,
  //     pauseOnHover:false,
  //     autoplaySpeed:5000,
  //     speed:1500,
  //     arrows: false,
  //     dots:false
  // });

  //remodal yt
  // $('.js-ymodal').on('click',function(){
  // 	const $yid=$(this).data('yid');
  // 	$('.js-modalmovie').attr("src","https://www.youtube.com/embed/"+$yid);
  // });
  // $(document).on('closed', '.remodal', function () {
  // 	$('.js-modalmovie').attr("src","");
  // });

  //ギャラリーページ
  $('.js-filterBox').each(function () {
    var $box = $(this);
    var $boxHead = $('.filterBox__head', $box);
    var $boxBody = $('.filterBox__body', $box);
    $boxHead.on('click', function () {
      $box.toggleClass('-open');
      $boxBody.slideToggle();
    });
  });
  $('.js-filterSp').on('click', function () {
    $('.galleryCnt__filter,.spFilterOverlay').fadeToggle();
  });
});
